<template>
  <v-container>
    <v-row v-if="sstart">
      <v-col class="mt-2 mt-md-4 text-center">
        <div class="d-flex justify-space-between align-items-center mb-3">
          <div style="flex: 1;"></div>
          <div class="mb-1 mb-md-2">
            <span class="text-h5 text-md-h4 font-weight-bold" :style="`color: ${darkMode ? '#f3f6f5' : '#172422'};`">Wybierz zestaw</span>
          </div>
          <div style="flex: 1; text-align: right;">
            <Statistics :darkMode="darkMode" class="d-inline-block mr-2" />
            <v-btn icon @click="toggleDarkMode" :title="darkMode ? 'Tryb jasny' : 'Tryb ciemny'" :style="`background: ${darkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(30, 45, 42, 0.06)'};`">
              <v-icon :color="darkMode ? '#fcd34d' : '#2d3e38'">{{ darkMode ? 'mdi-white-balance-sunny' : 'mdi-weather-night' }}</v-icon>
            </v-btn>
          </div>
        </div>
        <p class="text-body-2 text-md-subtitle-1 mb-4 mb-md-6" :style="`color: ${darkMode ? '#9cb0aa' : '#536561'};`">
          Zacznij swoją przygodę z nauką!
        </p>
        <div v-if="getProgressStats().totalDays > 0" class="mb-4">
          <v-chip small :style="`background: ${darkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(30, 45, 42, 0.06)'}; color: ${darkMode ? '#f3f6f5' : '#172422'};`" class="mr-2">
            <v-icon left x-small :color="darkMode ? '#fcd34d' : '#d97706'">mdi-calendar-check</v-icon>
            {{ getProgressStats().totalDays }} {{ getProgressStats().totalDays === 1 ? 'dzień' : 'dni' }}
          </v-chip>
          <v-chip small :style="`background: ${darkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(30, 45, 42, 0.06)'}; color: ${darkMode ? '#f3f6f5' : '#172422'};`" class="mr-2">
            <v-icon left x-small :color="darkMode ? '#34d399' : '#1d6e4e'">mdi-check-circle</v-icon>
            {{ getProgressStats().totalCorrect }} poprawnych
          </v-chip>
          <v-chip small v-if="getProgressStats().streak > 0" :style="`background: ${darkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(30, 45, 42, 0.06)'}; color: ${darkMode ? '#f3f6f5' : '#172422'};`">
            <v-icon left x-small :color="darkMode ? '#fb923c' : '#ea580c'">mdi-fire</v-icon>
            {{ getProgressStats().streak }} dni z rzędu
          </v-chip>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="sstart">
      <v-col cols="12">
        <v-select
          v-model="vzestaw"
          :items="zestawy_zdan"
          item-text="name"
          return-object
          label="Wybierz zestaw"
          outlined
          hide-details
          class="rounded-lg"
          :dark="darkMode"
          :color="darkMode ? '#f3f6f5' : '#1d6e4e'"
        >
          <template v-slot:prepend-inner>
            <v-icon :color="darkMode ? '#9cb0aa' : '#536561'">mdi-book-open-variant</v-icon>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title class="text-body-2 text-md-body-1">
                <v-chip
                  x-small
                  :style="`background: ${getLanguageColor(item)}; color: white;`"
                  class="mr-2 font-weight-bold"
                >
                  {{ getLanguageTag(item) }}
                </v-chip>
                <span :style="`color: ${darkMode ? '#f3f6f5' : '#172422'};`">{{ item.name }}</span>
              </v-list-item-title>
              <v-list-item-subtitle class="text-caption" :style="`color: ${darkMode ? '#9cb0aa' : '#536561'};`">
                {{ item.zdania.length }} {{ item.zdania.length === 1 ? 'zdanie' : 'zdań' }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template v-slot:selection="{ item }">
            <div class="d-flex align-center" style="width: 100%; overflow: hidden;">
              <v-chip
                x-small
                :style="`background: ${getLanguageColor(item)}; color: white;`"
                class="mr-2 font-weight-bold flex-shrink-0"
              >
                {{ getLanguageTag(item) }}
              </v-chip>
              <span :style="`color: ${darkMode ? '#f3f6f5' : '#172422'}; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;`" class="text-body-2">{{ item.name }}</span>
            </div>
          </template>
        </v-select>
      </v-col>
    </v-row>
    <v-row v-if="sstart">
      <v-col class="text-center">
        <v-btn
          :style="`background: ${vzestaw && vzestaw.lang ? getLanguageColor(vzestaw) : (darkMode ? '#60a5fa' : '#2563eb')} !important; color: white !important; text-transform: none; font-weight: 700; font-size: 17px; letter-spacing: 0.5px;`"
          large
          x-large
          rounded
          @click="st()"
          :disabled="!vzestaw"
          class="px-8 px-md-12 py-4 py-md-6"
          elevation="4"
          block
        >
          <v-icon left size="28">mdi-play-circle</v-icon>
          Start
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="!sstart" class="mb-2 mb-md-3" align="start">
      <v-col>
        <div class="ascent-status d-flex align-center justify-space-between mb-2">
          <span :style="`color: ${darkMode ? '#9cb0aa' : '#536561'};`">
            <v-icon small class="mr-1" :color="getLanguageColor(vzestaw)">mdi-terrain</v-icon>
            Trasa nauki
          </span>
          <span :style="`color: ${darkMode ? '#f3f6f5' : '#172422'}; font-weight: 700;`">{{ progressPercentage }}% ukończone</span>
        </div>
        <v-progress-linear
          :value="progressPercentage"
          height="10"
          rounded
          :style="`background: ${darkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(30, 45, 42, 0.1)'} !important;`"
          :color="getLanguageColor(vzestaw)"
          class="mb-3 mb-md-4"
        ></v-progress-linear>
        <div class="d-flex align-center justify-space-between flex-wrap">
          <div class="d-flex align-center flex-wrap mb-2 mb-md-0">
            <v-chip
              :style="`background: ${darkMode ? 'rgba(245, 158, 11, 0.22)' : '#fef3c7'}; color: ${darkMode ? '#fcd34d' : '#92400e'}; border: 1px solid ${darkMode ? '#b45309' : '#f59e0b'}; font-weight: 700;`"
              small
              class="mr-1 mr-md-2 mb-1 mb-md-0"
            >
              <v-icon left x-small small :color="darkMode ? '#fcd34d' : '#92400e'">mdi-star</v-icon>
              {{ punkty % 1 === 0 ? punkty : punkty.toFixed(1) }}
            </v-chip>
            <v-chip
              v-if="streak > 0"
              :style="`background: ${darkMode ? 'linear-gradient(135deg, #c2410c, #9a3412)' : 'linear-gradient(135deg, #ea580c, #c2410c)'}; color: white; font-weight: 700;`"
              small
              class="mr-1 mr-md-2 mb-1 mb-md-0"
            >
              <v-icon left x-small small color="white">mdi-fire</v-icon>
              {{ streak }}
            </v-chip>
            <v-chip
              :style="`background: ${darkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(30, 45, 42, 0.06)'}; color: ${darkMode ? '#f3f6f5' : '#172422'}; font-weight: 700;`"
              small
              class="mr-1 mr-md-2 mb-1 mb-md-0"
            >
              {{ correctAnswers }}/{{ totalAnswered }}
            </v-chip>
          </div>
          <div>
            <v-chip
              :style="getTimerChipStyle()"
              small
            >
              <v-icon left x-small small :color="getTimerIconColor()">mdi-clock-outline</v-icon>
              {{ formatTime(countDown) }}
            </v-chip>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="!sstart">
      <v-col>
        <v-card 
          elevation="0" 
          class="pa-3 pa-md-5 rounded-lg" 
          :style="getCardStyle()"
        >
          <div class="d-flex justify-space-between align-start">
            <div style="flex: 1;">
              <div class="d-flex align-center mb-2 mb-md-3">
                <v-chip
                  x-small
                  :style="`background: ${getLanguageColor(vzestaw)}; color: white; font-weight: 700;`"
                  class="mr-2"
                >
                  {{ getLanguageTag(vzestaw) }}
                </v-chip>
                <span class="text-caption text-md-subtitle-2 font-weight-medium" :style="`color: ${darkMode ? '#9cb0aa' : '#536561'};`">Przetłumacz na {{ getTargetLanguage() }}</span>
              </div>
              <div class="d-flex align-center mb-2 mb-md-3">
                <h2 class="text-h6 text-md-h5 mb-0 font-weight-bold" :style="`color: ${darkMode ? '#f3f6f5' : '#172422'}; line-height: 1.4; flex: 1;`">{{ zdanie.pl }}</h2>
                <v-btn
                  icon
                  x-small
                  small
                  :style="`background: ${darkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(30, 45, 42, 0.06)'} !important;`"
                  @click="speakText(zdanie.pl, 'pl')"
                  :disabled="odis || !speechAvailable"
                  class="ml-2 flex-shrink-0"
                  title="Posłuchaj po polsku"
                >
                  <v-icon x-small small :color="getLanguageColor(vzestaw)">mdi-volume-high</v-icon>
                </v-btn>
              </div>
              <v-expand-transition>
                <div v-if="showHint" class="mt-2 mt-md-3">
                  <v-chip 
                    x-small
                    small
                    :style="`background: ${darkMode ? 'rgba(245, 158, 11, 0.16)' : '#fdf6e9'}; color: ${darkMode ? '#fcd34d' : '#92400e'}; font-weight: 700; border: 1.5px solid ${darkMode ? '#b45309' : '#d97706'};`"
                  >
                    <v-icon left x-small :color="darkMode ? '#fcd34d' : '#d97706'">mdi-lightbulb-on</v-icon>
                    {{ getHint() }}
                  </v-chip>
                </div>
              </v-expand-transition>
            </div>
            <v-btn
              icon
              small
              :style="`background: ${showHint ? (darkMode ? 'rgba(245, 158, 11, 0.22)' : '#fef3c7') : (darkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(30, 45, 42, 0.06)')} !important;`"
              @click="showHint = !showHint; playSound('hint')"
              :disabled="odis"
              class="ml-2 flex-shrink-0"
            >
              <v-icon small :color="showHint ? (darkMode ? '#fcd34d' : '#d97706') : (darkMode ? '#9cb0aa' : '#536561')">{{ showHint ? 'mdi-lightbulb-on' : 'mdi-lightbulb-outline' }}</v-icon>
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="!sstart">
      <v-col>
        <v-text-field
          v-model="odpowiedz"
          label="Wpisz odpowiedź..."
          clearable
          :disabled="odis"
          outlined
          autofocus
          hide-details
          class="compact-input"
          :class="{ 'dark-input': darkMode }"
          @keydown.enter="sprawdz()"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
          :dark="darkMode"
        >
          <template v-slot:prepend-inner>
            <v-icon :color="getLanguageColor(vzestaw)" size="20">mdi-pencil</v-icon>
          </template>
          <template v-slot:append v-if="vzestaw.lang === 'de' || vzestaw.lang === 'fr'">
            <div class="d-flex flex-wrap" style="max-width: 160px;">
              <template v-if="vzestaw.lang === 'de'">
                <v-btn x-small text @click="insertChar('ä')" :style="`min-width: 28px; padding: 0 4px; color: ${darkMode ? '#f3f6f5' : '#172422'}; font-weight: 700;`">ä</v-btn>
                <v-btn x-small text @click="insertChar('ö')" :style="`min-width: 28px; padding: 0 4px; color: ${darkMode ? '#f3f6f5' : '#172422'}; font-weight: 700;`">ö</v-btn>
                <v-btn x-small text @click="insertChar('ü')" :style="`min-width: 28px; padding: 0 4px; color: ${darkMode ? '#f3f6f5' : '#172422'}; font-weight: 700;`">ü</v-btn>
                <v-btn x-small text @click="insertChar('ß')" :style="`min-width: 28px; padding: 0 4px; color: ${darkMode ? '#f3f6f5' : '#172422'}; font-weight: 700;`">ß</v-btn>
              </template>
              <template v-if="vzestaw.lang === 'fr'">
                <v-btn x-small text @click="insertChar('é')" :style="`min-width: 28px; padding: 0 4px; color: ${darkMode ? '#f3f6f5' : '#172422'}; font-weight: 700;`">é</v-btn>
                <v-btn x-small text @click="insertChar('è')" :style="`min-width: 28px; padding: 0 4px; color: ${darkMode ? '#f3f6f5' : '#172422'}; font-weight: 700;`">è</v-btn>
                <v-btn x-small text @click="insertChar('à')" :style="`min-width: 28px; padding: 0 4px; color: ${darkMode ? '#f3f6f5' : '#172422'}; font-weight: 700;`">à</v-btn>
                <v-btn x-small text @click="insertChar('ç')" :style="`min-width: 28px; padding: 0 4px; color: ${darkMode ? '#f3f6f5' : '#172422'}; font-weight: 700;`">ç</v-btn>
                <v-btn x-small text @click="insertChar('ù')" :style="`min-width: 28px; padding: 0 4px; color: ${darkMode ? '#f3f6f5' : '#172422'}; font-weight: 700;`">ù</v-btn>
                <v-btn x-small text @click="insertChar('î')" :style="`min-width: 28px; padding: 0 4px; color: ${darkMode ? '#f3f6f5' : '#172422'}; font-weight: 700;`">î</v-btn>
                <v-btn x-small text @click="insertChar('ô')" :style="`min-width: 28px; padding: 0 4px; color: ${darkMode ? '#f3f6f5' : '#172422'}; font-weight: 700;`">ô</v-btn>
                <v-btn x-small text @click="insertChar('œ')" :style="`min-width: 28px; padding: 0 4px; color: ${darkMode ? '#f3f6f5' : '#172422'}; font-weight: 700;`">œ</v-btn>
              </template>
            </div>
          </template>
        </v-text-field>
        <p class="text-caption mt-2 mb-0" :style="`color: ${darkMode ? '#9cb0aa' : '#536561'};`">
          <v-icon small :color="darkMode ? '#9cb0aa' : '#536561'">mdi-keyboard</v-icon>
          <span class="d-none d-sm-inline">Enter = sprawdź • Spacja = pomiń • ? = podpowiedź</span>
          <span class="d-inline d-sm-none">Enter • Spacja • ?</span>
        </p>
      </v-col>
    </v-row>
    <v-row class="text-center" v-if="!sstart">
      <v-col cols="12">
        <v-btn
          :style="`background: ${getLanguageColor(vzestaw)} !important; color: white !important; text-transform: none; font-weight: 700; font-size: 16px; letter-spacing: 0.5px;`"
          large
          rounded
          :disabled="!odpowiedz || odis"
          @click.stop="sprawdz()"
          class="px-6 px-md-10 mb-2 mb-md-0 mr-0 mr-md-3"
          elevation="4"
          :block="$vuetify.breakpoint.xs"
        >
          <v-icon left>mdi-check-bold</v-icon>
          Sprawdź
        </v-btn>
        <v-btn
          :style="`background: ${darkMode ? 'rgba(255, 255, 255, 0.09)' : 'rgba(30, 45, 42, 0.07)'} !important; color: ${darkMode ? '#9cb0aa' : '#536561'} !important; text-transform: none; font-weight: 700;`"
          large
          rounded
          @click="skipQuestion()"
          :disabled="odis"
          elevation="0"
          class="px-6"
          :block="$vuetify.breakpoint.xs"
        >
          <v-icon left>mdi-skip-next</v-icon>
          Pomiń
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-alert 
          :value="alert" 
          elevation="0"
          class="rounded-lg"
          :style="`background: ${darkMode ? 'linear-gradient(135deg, #144633, #0d3224)' : 'linear-gradient(135deg, #1e7150, #16583d)'} !important; border-left: 6px solid ${darkMode ? '#34d399' : '#0c3826'}; color: white !important; box-shadow: 0 4px 14px ${darkMode ? 'rgba(0,0,0,0.3)' : 'rgba(30, 113, 80, 0.2)'} !important;`"
        >
          <div class="d-flex align-center">
            <v-icon left size="28" class="d-none d-sm-flex" color="white">mdi-check-circle</v-icon>
            <v-icon left size="24" class="d-flex d-sm-none" color="white">mdi-check-circle</v-icon>
            <div>
              <div class="text-subtitle-1 text-md-h6 font-weight-bold">{{ getSuccessMessage() }}</div>
              <div class="text-caption font-weight-medium" style="opacity: 0.95;">+1 punkt</div>
            </div>
          </div>
        </v-alert>
        <v-alert 
          :value="badalert" 
          elevation="0"
          class="rounded-lg"
          :style="`background: ${darkMode ? 'linear-gradient(135deg, #521a15, #3c120f)' : 'linear-gradient(135deg, #b83a2c, #9d2f23)'} !important; border-left: 6px solid ${darkMode ? '#f87171' : '#791f16'}; color: white !important; box-shadow: 0 4px 14px ${darkMode ? 'rgba(0,0,0,0.3)' : 'rgba(184, 58, 44, 0.2)'} !important;`"
        >
          <div class="d-flex align-center justify-space-between flex-wrap">
            <div class="mb-2 mb-md-0" style="flex: 1; min-width: 0;">
              <div class="d-flex align-center mb-2">
                <v-icon left small color="white">mdi-close-circle</v-icon>
                <span class="text-caption text-md-subtitle-1 font-weight-bold">Poprawna odpowiedź:</span>
              </div>
              <div class="text-body-1 text-md-h6 font-weight-bold" style="word-break: break-word;">{{ gooda }}</div>
            </div>
            <div class="d-flex align-center ml-2 flex-shrink-0">
              <v-btn
                fab
                x-small
                small
                style="background: white !important;"
                elevation="0"
                @click.stop="sp()"
                class="mr-2"
                :disabled="!speechAvailable"
                title="Posłuchaj wymowy"
              >
                <v-icon small :color="darkMode ? '#ef4444' : '#b83a2c'">mdi-volume-high</v-icon>
              </v-btn>
              <v-btn
                small
                :style="`background: white !important; color: ${darkMode ? '#ef4444' : '#b83a2c'} !important; font-weight: 700;`"
                elevation="0"
                @click.stop="nextQuestion()"
                title="Następne pytanie (Esc)"
              >
                <v-icon left small>mdi-arrow-right</v-icon>
                Dalej
              </v-btn>
            </div>
          </div>
        </v-alert>
        <v-alert 
          :value="info" 
          elevation="0"
          class="rounded-lg"
          :style="`background: ${darkMode ? 'linear-gradient(135deg, #111a19, #1c2926)' : 'linear-gradient(135deg, #1b2727, #2d3e38)'} !important; border-left: 6px solid ${darkMode ? '#f59e0b' : '#d97706'}; color: #f8f4ed !important; box-shadow: 0 4px 18px rgba(27, 39, 39, 0.3) !important;`"
        >
          <div class="text-center">
            <v-icon size="48" color="#fcd34d" class="mb-3 d-none d-sm-block">mdi-trophy</v-icon>
            <v-icon size="40" color="#fcd34d" class="mb-2 d-block d-sm-none">mdi-trophy</v-icon>
            <div class="text-h6 text-md-h5 mb-2 font-weight-bold" style="color: #f8f4ed;">Koniec gry!</div>
            <div class="text-subtitle-1 text-md-h6 mb-2 font-weight-bold" style="color: #d9ad81;">Zdobyłeś {{ punkty % 1 === 0 ? punkty : punkty.toFixed(1) }} {{ punkty === 1 ? 'punkt' : 'punktów' }}</div>
            <div class="text-body-2 text-md-subtitle-1 mt-2 font-weight-medium" style="color: rgba(248, 244, 237, 0.85);">
              Poprawność: {{ totalAnswered > 0 ? Math.round((correctAnswers / totalAnswered) * 100) : 0 }}%
            </div>
          </div>
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="!sstart && errors">
      <v-col>
        <v-card 
          elevation="0" 
          class="rounded-lg" 
          :style="`background: ${darkMode ? 'rgba(45, 30, 15, 0.45)' : '#fdfaf3'}; border: 2px solid ${darkMode ? 'rgba(245, 158, 11, 0.35)' : 'rgba(217, 119, 6, 0.35)'};`"
        >
          <div class="pa-3 pa-md-4">
            <div class="d-flex align-center mb-2 mb-md-3">
              <v-icon :color="darkMode ? '#fcd34d' : '#d97706'" class="mr-2" small>mdi-alert-circle</v-icon>
              <span class="text-body-2 text-md-subtitle-1 font-weight-bold" :style="`color: ${darkMode ? '#f3f6f5' : '#172422'};`">
                Do powtórzenia ({{ errorCount }})
              </span>
            </div>
            <v-textarea
              outlined
              auto-grow
              readonly
              :value="errors"
              rows="3"
              hide-details
              class="rounded-lg text-body-2"
              :style="`background: ${darkMode ? 'rgba(15, 23, 30, 0.6)' : '#ffffff'}; border: 1.5px solid ${darkMode ? 'rgba(245, 158, 11, 0.25)' : 'rgba(217, 119, 6, 0.2)'}; color: ${darkMode ? '#f3f6f5' : '#172422'};`"
            ></v-textarea>
            <div class="text-right mt-2 mt-md-3">
              <v-btn
                text
                x-small
                small
                :style="`color: ${darkMode ? '#9cb0aa' : '#536561'}; text-transform: none;`"
                @click="errors = ''; errorCount = 0"
              >
                <v-icon left x-small small>mdi-close</v-icon>
                Wyczyść
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { loadAllWordSets, getCustomWordSets } from '@/data/dataLoader.js';
import { getWordsForReview, recordReview, getSetMastery } from '@/utils/spacedRepetition.js';
import { saveSession } from '@/utils/statistics.js';
import Statistics from './Statistics.vue';
import confetti from 'canvas-confetti';

export default {
  name: "Langi",
  components: {
    Statistics,
  },

  data: () => ({
    zdanie: {},
    odpowiedz: "",
    alert: false,
    badalert: false,
    sstart: true,
    info: false,
    gooda: "",
    odis: true,
    punkty: 0,
    countDown: 500,
    vzestaw: {},
    streak: 0,
    totalAnswered: 0,
    correctAnswers: 0,
    showHint: false,
    errorCount: 0,
    audioContext: null,
    soundEnabled: true,
    speechAvailable: false,
    darkMode: false,
    questionHistory: {}, // Track answered questions: { questionId: 'correct'|'wrong'|'skipped' }
    zestawy_zdan: [],
    zdania: {},
    errors: "",
    sessionStartTime: null,
    maxStreak: 0,
    questionStartTime: null,
  }),
  computed: {
    progressPercentage() {
      if (!this.vzestaw || !this.vzestaw.zdania) return 0;
      return Math.min(100, Math.round((this.totalAnswered / this.vzestaw.zdania.length) * 100));
    },
  },
  watch: {
    progressPercentage(value) {
      this.$emit('learning-progress', value);
    },
  },
  async beforeMount() {
    // Load all word sets (legacy + JSON + custom)
    this.zestawy_zdan = await loadAllWordSets();
    
    // Add custom sets from localStorage
    const customSets = getCustomWordSets();
    this.zestawy_zdan = [...this.zestawy_zdan, ...customSets];
    
    this.vzestaw = this.zestawy_zdan[0];
    
    // Initialize audio context
    if (typeof AudioContext !== 'undefined' || typeof webkitAudioContext !== 'undefined') {
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
    }
    // Check if speech synthesis is available
    this.speechAvailable = 'speechSynthesis' in window;
    
    // Load dark mode preference
    const savedDarkMode = localStorage.getItem('langi_darkMode');
    if (savedDarkMode !== null) {
      this.darkMode = savedDarkMode === 'true';
    }
    
    // Load today's progress
    this.loadTodayProgress();
    
    // Add keyboard event listener
    window.addEventListener('keydown', this.handleKeyPress);
  },
  
  beforeDestroy() {
    // Remove keyboard event listener
    window.removeEventListener('keydown', this.handleKeyPress);
  },

  methods: {
    // Keyboard shortcuts
    handleKeyPress(event) {
      // Only handle shortcuts when game is active
      if (this.sstart) return;
      
      // Escape key - Next question (when wrong answer is shown)
      if (event.key === 'Escape') {
        if (this.badalert) {
          event.preventDefault();
          this.nextQuestion();
        }
      }
      
      // Space key - Skip question (only when not typing in input)
      if (event.key === ' ' && event.target.tagName !== 'INPUT') {
        if (!this.odis && !this.alert && !this.badalert) {
          event.preventDefault();
          this.skipQuestion();
        }
      }
      
      // ? key - Show hint
      if (event.key === '?') {
        if (!this.odis && !this.alert && !this.badalert) {
          event.preventDefault();
          this.showHint = !this.showHint;
          if (this.showHint) this.playSound('hint');
        }
      }
    },
    
    // Next question button (for wrong answers)
    nextQuestion() {
      this.badalert = false;
      this.odpowiedz = "";
      this.gooda = "";
      this.showHint = false;
      this.odis = false;
      this.losuj();
    },
    
    // Progress tracking
    loadTodayProgress() {
      const today = new Date().toISOString().split('T')[0];
      const progress = JSON.parse(localStorage.getItem('langi_progress') || '{}');
      
      if (!progress[today]) {
        progress[today] = {
          attempts: 0,
          correct: 0,
          wrong: 0,
          sets: []
        };
      }
      
      return progress[today];
    },
    
    saveProgress() {
      const today = new Date().toISOString().split('T')[0];
      const progress = JSON.parse(localStorage.getItem('langi_progress') || '{}');
      
      if (!progress[today]) {
        progress[today] = {
          attempts: 0,
          correct: 0,
          wrong: 0,
          sets: []
        };
      }
      
      progress[today].attempts = this.totalAnswered;
      progress[today].correct = this.correctAnswers;
      progress[today].wrong = this.errorCount;
      
      if (this.vzestaw && this.vzestaw.name && !progress[today].sets.includes(this.vzestaw.name)) {
        progress[today].sets.push(this.vzestaw.name);
      }
      
      // Keep only last 30 days
      const dates = Object.keys(progress).sort();
      if (dates.length > 30) {
        dates.slice(0, dates.length - 30).forEach(date => delete progress[date]);
      }
      
      localStorage.setItem('langi_progress', JSON.stringify(progress));
    },
    
    getProgressStats() {
      const progress = JSON.parse(localStorage.getItem('langi_progress') || '{}');
      const dates = Object.keys(progress).sort();
      
      return {
        totalDays: dates.length,
        totalAttempts: dates.reduce((sum, date) => sum + (progress[date].attempts || 0), 0),
        totalCorrect: dates.reduce((sum, date) => sum + (progress[date].correct || 0), 0),
        streak: this.calculateStreak(dates)
      };
    },
    
    calculateStreak(dates) {
      if (dates.length === 0) return 0;
      
      let streak = 0;
      const today = new Date().toISOString().split('T')[0];
      let checkDate = new Date(today);
      
      for (let i = dates.length - 1; i >= 0; i--) {
        const dateStr = checkDate.toISOString().split('T')[0];
        if (dates[i] === dateStr) {
          streak++;
          checkDate.setDate(checkDate.getDate() - 1);
        } else {
          break;
        }
      }
      
      return streak;
    },
    
    // Confetti celebration
    celebrateWithConfetti() {
      const duration = 3000;
      const animationEnd = Date.now() + duration;
      const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };

      function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
      }

      const interval = setInterval(function() {
        const timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
          return clearInterval(interval);
        }

        const particleCount = 50 * (timeLeft / duration);
        
        confetti(Object.assign({}, defaults, {
          particleCount,
          origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
        }));
        confetti(Object.assign({}, defaults, {
          particleCount,
          origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
        }));
      }, 250);
    },
    
    // Dark mode toggle
    toggleDarkMode() {
      this.darkMode = !this.darkMode;
      localStorage.setItem('langi_darkMode', this.darkMode);
      this.$emit('dark-mode-changed', this.darkMode);
    },
    
    // Get set mastery info
    getSetMasteryInfo(set) {
      if (!set || !set.zdania) return null;
      return getSetMastery(set.zdania);
    },
    
    speakText(text, lang) {
      if (!this.speechAvailable || !text) return;
      
      // Cancel any ongoing speech
      window.speechSynthesis.cancel();
      
      const utterance = new SpeechSynthesisUtterance(text);
      
      // Set language based on the set
      if (lang === 'en') {
        utterance.lang = 'en-US';
      } else if (lang === 'de') {
        utterance.lang = 'de-DE';
      } else if (lang === 'fr') {
        utterance.lang = 'fr-FR';
      } else if (lang === 'pl') {
        utterance.lang = 'pl-PL';
      }

      // Set voice properties
      utterance.rate = 0.9; // Slightly slower for learning
      utterance.pitch = 1.0;
      utterance.volume = 0.8;

      // Try to find a native voice for the language
      const langPrefix = { en: 'en', de: 'de', fr: 'fr', pl: 'pl' }[lang] || lang;
      const voices = window.speechSynthesis.getVoices();
      const nativeVoice = voices.find(voice => voice.lang.startsWith(langPrefix));
      if (nativeVoice) {
        utterance.voice = nativeVoice;
      }
      
      window.speechSynthesis.speak(utterance);
    },
    speakCountdown(number) {
      if (!this.speechAvailable) return;
      
      window.speechSynthesis.cancel();
      
      const utterance = new SpeechSynthesisUtterance(number.toString());
      utterance.lang = 'pl-PL';
      utterance.rate = 1.0;
      utterance.pitch = 1.2;
      utterance.volume = 0.9;
      
      const voices = window.speechSynthesis.getVoices();
      const polishVoice = voices.find(voice => voice.lang.startsWith('pl'));
      if (polishVoice) {
        utterance.voice = polishVoice;
      }
      
      window.speechSynthesis.speak(utterance);
    },
    playSound(type) {
      if (!this.audioContext || !this.soundEnabled) return;
      
      const ctx = this.audioContext;
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);
      
      // Set volume (very subtle)
      gainNode.gain.setValueAtTime(0.1, ctx.currentTime);
      
      if (type === 'success') {
        // Pleasant ascending chime
        oscillator.frequency.setValueAtTime(523.25, ctx.currentTime); // C5
        oscillator.frequency.setValueAtTime(659.25, ctx.currentTime + 0.1); // E5
        oscillator.frequency.setValueAtTime(783.99, ctx.currentTime + 0.2); // G5
        oscillator.type = 'sine';
        gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.4);
        oscillator.start(ctx.currentTime);
        oscillator.stop(ctx.currentTime + 0.4);
      } else if (type === 'error') {
        // Gentle descending tone
        oscillator.frequency.setValueAtTime(392.00, ctx.currentTime); // G4
        oscillator.frequency.setValueAtTime(329.63, ctx.currentTime + 0.15); // E4
        oscillator.type = 'sine';
        gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.3);
        oscillator.start(ctx.currentTime);
        oscillator.stop(ctx.currentTime + 0.3);
      } else if (type === 'click') {
        // Soft click
        oscillator.frequency.setValueAtTime(800, ctx.currentTime);
        oscillator.type = 'sine';
        gainNode.gain.setValueAtTime(0.05, ctx.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.05);
        oscillator.start(ctx.currentTime);
        oscillator.stop(ctx.currentTime + 0.05);
      } else if (type === 'complete') {
        // Victory fanfare (subtle)
        const notes = [523.25, 659.25, 783.99, 1046.50]; // C5, E5, G5, C6
        notes.forEach((freq, i) => {
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.connect(gain);
          gain.connect(ctx.destination);
          osc.frequency.setValueAtTime(freq, ctx.currentTime + i * 0.1);
          osc.type = 'sine';
          gain.gain.setValueAtTime(0.08, ctx.currentTime + i * 0.1);
          gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + i * 0.1 + 0.3);
          osc.start(ctx.currentTime + i * 0.1);
          osc.stop(ctx.currentTime + i * 0.1 + 0.3);
        });
      } else if (type === 'hint') {
        // Gentle notification
        oscillator.frequency.setValueAtTime(880, ctx.currentTime); // A5
        oscillator.type = 'sine';
        gainNode.gain.setValueAtTime(0.06, ctx.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.2);
        oscillator.start(ctx.currentTime);
        oscillator.stop(ctx.currentTime + 0.2);
      } else if (type === 'ping') {
        // Urgent ping for countdown
        oscillator.frequency.setValueAtTime(1200, ctx.currentTime); // High pitch
        oscillator.type = 'sine';
        gainNode.gain.setValueAtTime(0.15, ctx.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.15);
        oscillator.start(ctx.currentTime);
        oscillator.stop(ctx.currentTime + 0.15);
      }
    },
    toggleSound() {
      this.soundEnabled = !this.soundEnabled;
      if (this.soundEnabled) {
        this.playSound('click');
      }
    },
    getLanguageTag(set) {
      if (!set) return 'DE';
      if (set.lang === 'en') return 'EN';
      if (set.lang === 'fr') return 'FR';
      return 'DE';
    },
    getLanguageColor(set) {
      if (!set) return this.darkMode ? '#60a5fa' : '#2563eb';
      if (set.lang === 'en') return this.darkMode ? '#60a5fa' : '#2563eb'; // Blue
      if (set.lang === 'fr') return this.darkMode ? '#34d399' : '#1d6e4e'; // Green
      return this.darkMode ? '#f59e0b' : '#d97706'; // Amber (DE)
    },
    getTargetLanguage() {
      if (this.vzestaw && this.vzestaw.lang) {
        if (this.vzestaw.lang === 'en') return 'angielski';
        if (this.vzestaw.lang === 'fr') return 'francuski';
      }
      return 'niemiecki';
    },
    getCardColor() {
      const lang = this.vzestaw && this.vzestaw.lang ? this.vzestaw.lang : 'de';
      if (this.darkMode) {
        if (lang === 'en') return 'rgba(37, 99, 235, 0.12)';
        if (lang === 'fr') return 'rgba(29, 110, 78, 0.14)';
        return 'rgba(217, 119, 6, 0.14)';
      }
      if (lang === 'en') return 'rgba(37, 99, 235, 0.04)';
      if (lang === 'fr') return 'rgba(29, 110, 78, 0.04)';
      return 'rgba(217, 119, 6, 0.04)';
    },
    getCardStyle() {
      const lang = this.vzestaw && this.vzestaw.lang ? this.vzestaw.lang : 'de';
      if (this.darkMode) {
        if (lang === 'en') {
          return 'background: rgba(37, 99, 235, 0.12); border: 2px solid rgba(96, 165, 250, 0.35);';
        }
        if (lang === 'fr') {
          return 'background: rgba(29, 110, 78, 0.14); border: 2px solid rgba(52, 211, 153, 0.35);';
        }
        return 'background: rgba(217, 119, 6, 0.14); border: 2px solid rgba(245, 158, 11, 0.35);';
      } else {
        if (lang === 'en') {
          return 'background: rgba(37, 99, 235, 0.04); border: 2px solid rgba(37, 99, 235, 0.28);';
        }
        if (lang === 'fr') {
          return 'background: rgba(29, 110, 78, 0.04); border: 2px solid rgba(29, 110, 78, 0.28);';
        }
        return 'background: rgba(217, 119, 6, 0.04); border: 2px solid rgba(217, 119, 6, 0.28);';
      }
    },
    getTimerChipStyle() {
      if (this.countDown < 60) {
        return this.darkMode
          ? 'background: #7c2016; color: #fee2e2; border: 1px solid #f87171; font-weight: 700;'
          : 'background: #b83a2c; color: white; font-weight: 700;';
      }
      if (this.countDown < 120) {
        return this.darkMode
          ? 'background: rgba(245, 158, 11, 0.22); color: #fcd34d; border: 1px solid #b45309; font-weight: 700;'
          : 'background: #fef3c7; color: #92400e; border: 1px solid #f59e0b; font-weight: 700;';
      }
      return `background: ${this.getLanguageColor(this.vzestaw)}; color: white; font-weight: 700;`;
    },
    getTimerIconColor() {
      if (this.countDown < 60) {
        return this.darkMode ? '#fee2e2' : 'white';
      }
      if (this.countDown < 120) {
        return this.darkMode ? '#fcd34d' : '#92400e';
      }
      return 'white';
    },
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return mins > 0 ? `${mins}:${secs.toString().padStart(2, '0')}` : `${secs}s`;
    },
    getSuccessMessage() {
      const messages = [
        'Świetnie!',
        'Brawo!',
        'Doskonale!',
        'Super!',
        'Wspaniale!',
        'Tak trzymaj!',
        'Jesteś dobry!',
        'Fantastycznie!'
      ];
      return messages[Math.floor(Math.random() * messages.length)];
    },
    getHint() {
      if (!this.zdanie.de) return '';
      const words = this.zdanie.de.split(' ');
      if (words.length === 1) {
        return this.zdanie.de.substring(0, 2) + '...';
      }
      return `Pierwsze słowo: ${words[0]}`;
    },
    skipQuestion() {
      const questionId = this.zdanie.pl + this.zdanie.de;
      this.questionHistory[questionId] = 'skipped';
      
      this.showHint = false;
      this.odpowiedz = "";
      this.streak = 0;
      this.playSound('click');
      this.losuj();
    },
    
    insertChar(char) {
      const input = this.odpowiedz || '';
      this.odpowiedz = input + char;
    },
    
    hide_alert(atime) {
      const interval = window.setInterval(() => {
        this.alert = false;
        this.badalert = false;
        this.odpowiedz = "";
        this.gooda = "";
        this.showHint = false;
        this.odis = false; // Re-enable input before switching

        this.losuj();
        clearInterval(interval);
      }, atime);
    },
    st() {
      // Use spaced repetition to prioritize words
      const allWords = [...this.vzestaw.zdania];
      this.zdania = getWordsForReview(allWords);
      
      this.questionHistory = {}; // Reset history for new game
      this.sessionStartTime = Date.now();
      this.maxStreak = 0;
      this.losuj();
      this.sstart = false;
      this.odis = false;
      this.countDownTimer();
      this.errors = "";
      this.punkty = 0;
      this.streak = 0;
      this.totalAnswered = 0;
      this.correctAnswers = 0;
      this.showHint = false;
      this.errorCount = 0;
      this.playSound('click');
    },
    losuj() {
      // Create weighted selection based on question history
      const unanswered = [];
      const wrong = [];
      const skipped = [];
      const correct = [];
      
      this.zdania.forEach((q) => {
        const questionId = q.pl + q.de; // Unique identifier
        const status = this.questionHistory[questionId];
        
        if (!status) {
          unanswered.push(q);
        } else if (status === 'wrong') {
          wrong.push(q);
        } else if (status === 'skipped') {
          skipped.push(q);
        } else if (status === 'correct') {
          correct.push(q);
        }
      });
      
      // Priority: unanswered > wrong > skipped > correct
      let selectedPool;
      if (unanswered.length > 0) {
        selectedPool = unanswered;
      } else if (wrong.length > 0) {
        selectedPool = wrong;
      } else if (skipped.length > 0) {
        selectedPool = skipped;
      } else {
        // All answered correctly, reset and start over
        this.questionHistory = {};
        selectedPool = this.zdania;
      }
      
      this.zdanie = selectedPool[Math.floor(Math.random() * selectedPool.length)];
      this.questionStartTime = Date.now();
    },
    async sp() {
      if (this.gooda && this.vzestaw && this.vzestaw.lang) {
        this.speakText(this.gooda, this.vzestaw.lang);
      }
    },
    normalizeAnswer(str) {
      return str
        .replace(/['']/g, "'")
        .replace(/…/g, '')
        .replace(/\.\.\./g, '')
        .replace(/\./g, '')
        .replace(/:/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    },
    sprawdz() {
      let odp = this.normalizeAnswer(this.odpowiedz.replace(" ?", "?"));
      let ok = this.normalizeAnswer(this.zdanie.de.toUpperCase());

      const questionId = this.zdanie.pl + this.zdanie.de;
      this.totalAnswered++;
      this.odis = true; // Disable input immediately to prevent typing during transition

      // Check for exact match
      if (ok === odp.toUpperCase()) {
        const responseTime = (Date.now() - this.questionStartTime) / 1000;
        recordReview(this.zdanie, true, responseTime);
        
        this.questionHistory[questionId] = 'correct';
        this.alert = true;
        this.punkty = this.punkty + 1;
        this.correctAnswers++;
        this.streak++;
        this.maxStreak = Math.max(this.maxStreak, this.streak);
        this.$emit('answer-result', true);
        this.playSound('success');
        this.saveProgress();
        this.hide_alert(1500);
        return;
      }

      // Check for partial match (slash-separated alternatives)
      const correctAnswers = ok.split('/').map(a => a.trim());
      const userAnswer = odp.toUpperCase();
      
      if (correctAnswers.some(answer => answer === userAnswer)) {
        // Exact match with one of the alternatives
        this.questionHistory[questionId] = 'correct';
        this.alert = true;
        this.punkty = this.punkty + 1;
        this.correctAnswers++;
        this.streak++;
        this.$emit('answer-result', true);
        this.playSound('success');
        this.saveProgress();
        this.hide_alert(1500);
        return;
      }
      
      // Check if user provided one valid part (half point)
      const userProvidedValidPart = correctAnswers.some(answer => answer === userAnswer);
      if (userProvidedValidPart || correctAnswers.length > 1 && correctAnswers.some(answer => answer === userAnswer)) {
        this.questionHistory[questionId] = 'correct';
        this.alert = true;
        this.punkty = this.punkty + 0.5;
        this.correctAnswers += 0.5;
        this.streak++;
        this.$emit('answer-result', true);
        this.playSound('success');
        this.saveProgress();
        this.hide_alert(1500);
        return;
      }

      // Wrong answer
      const responseTime = (Date.now() - this.questionStartTime) / 1000;
      recordReview(this.zdanie, false, responseTime);
      
      this.questionHistory[questionId] = 'wrong';
      this.gooda = this.zdanie.de;
      this.badalert = true;
      this.streak = 0;
      this.errorCount++;
      this.$emit('answer-result', false);
      this.playSound('error');
      this.saveProgress();
      this.errors = this.errors + this.zdanie.pl + " → " + this.gooda + "\n";
      // Don't auto-hide for wrong answers - user must click "Next" or press N
    },
    countDownTimer() {
      if (this.countDown > 0) {
        // Ping sound for last 10 seconds
        if (this.countDown <= 10) {
          this.playSound('ping');
        }
        
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      } else {
        this.info = true;
        this.odis = true;
        this.countDown = 500;
        this.playSound('complete');
        this.celebrateWithConfetti();
        this.saveProgress();
        
        // Save session statistics
        const sessionDuration = Math.round((Date.now() - this.sessionStartTime) / 1000);
        saveSession({
          setName: this.vzestaw.name,
          totalAnswered: this.totalAnswered,
          correctAnswers: this.correctAnswers,
          score: this.punkty,
          maxStreak: this.maxStreak,
          duration: sessionDuration,
        });
        
        const interval = window.setInterval(() => {
          this.info = false;

          clearInterval(interval);
        }, 5000);
        this.sstart = true;
      }
    },
  },
};
</script>

<style scoped>
.ascent-status {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

/* Compact input field */
.compact-input {
  border-radius: 14px !important;
}

.compact-input >>> .v-input__control {
  min-height: 56px !important;
}

.compact-input >>> .v-input__slot {
  min-height: 56px !important;
  padding: 0 12px !important;
}

.compact-input >>> .v-text-field__slot {
  height: 56px !important;
}

.compact-input >>> .v-text-field__slot input {
  font-size: 16px !important;
  line-height: 20px !important;
  padding: 0 !important;
  margin-top: 0 !important;
}

.compact-input >>> .v-label {
  top: 18px !important;
}

.compact-input >>> .v-label--active {
  transform: translateY(-18px) scale(0.75) !important;
}

.compact-input >>> fieldset {
  border-width: 2px !important;
  border-radius: 14px !important;
}

.compact-input.v-text-field--outlined >>> fieldset {
  border-color: rgba(30, 45, 42, 0.22) !important;
}

.compact-input.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #1d6e4e !important;
}

.compact-input.v-text-field--outlined.theme--dark >>> fieldset {
  border-color: rgba(148, 163, 184, 0.24) !important;
}

.compact-input.v-text-field--outlined.theme--dark.v-input--is-focused >>> fieldset {
  border-color: #34d399 !important;
}

/* Dark mode input */
.dark-input >>> .v-text-field__slot input {
  color: #f3f6f5 !important;
}

.dark-input >>> .v-label {
  color: #9cb0aa !important;
}

.dark-input >>> .v-input__slot {
  background-color: rgba(17, 26, 36, 0.75) !important;
}

/* Dark mode select dropdown */
.v-select.theme--dark >>> .v-select__selections {
  color: #f3f6f5 !important;
}

.v-select.theme--dark >>> .v-input__slot {
  background-color: rgba(17, 26, 36, 0.75) !important;
}

.v-select.theme--dark >>> .v-label {
  color: #9cb0aa !important;
}

/* Dark mode menu list */
.theme--dark.v-list {
  background-color: #16222f !important;
}

.theme--dark.v-list-item {
  color: #f3f6f5 !important;
}

.theme--dark.v-list-item__title {
  color: #f3f6f5 !important;
}

.theme--dark.v-list-item__subtitle {
  color: #9cb0aa !important;
}

.theme--dark.v-list-item:hover {
  background-color: #243547 !important;
}
</style>
